import { Controller } from '@hotwired/stimulus';

import { phoneNumberFormatter } from '../../../lib/intlTelInput.js';

export default class PhoneNumberController extends Controller {
  static targets = ['phoneInput'];
  static values = { countryOrder: { type: Array, default: ['fr'] } };

  phoneInputTargetConnected() {
    phoneNumberFormatter({
      inputId: `#${this.phoneInputTarget.id}`,
      phoneAttributeName: this.phoneInputTarget.name,
      countryOrder: this.countryOrderValue,
    });
  }
}
